module.exports = __webpack_public_path__ + "img/get_assistance.e30e7ae2.png";